/* Progressive presentation only. Shopify retains every consent handler and value. */
(() => {
  const template = document.getElementById('HnCookieBrand');
  if (!template) return;
  function enhance() {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.hnCompact) return;
    const body = banner.querySelector('.shopify-pc__banner__body');
    const heading = banner.querySelector('h2');
    const paragraphs = body ? [...body.querySelectorAll('p')] : [];
    if (!body || !heading || !paragraphs.length) return;
    banner.dataset.hnCompact = 'true';
    heading.prepend(template.content.cloneNode(true));
    const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    const preferencesLabel = preferences?.querySelector('span');
    const preferencesIcon = document.getElementById('HnCookiePreferencesIcon');
    if (preferencesLabel && preferencesIcon) {
      preferences.title = preferencesLabel.textContent.trim();
      preferencesLabel.classList.add('visually-hidden');
      preferences.append(preferencesIcon.content.cloneNode(true));
    }
    // Keep unconfigured translations fully visible instead of introducing English copy.
    if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;
    const intro = document.createElement('p');
    intro.className = 'hn-cookie-intro';
    intro.textContent = 'Choose how optional cookies are used.';
    const details = document.createElement('details');
    details.className = 'hn-cookie-details';
    const summary = document.createElement('summary');
    summary.textContent = 'What does this mean?';
    details.append(summary);
    paragraphs[0].before(intro, details);
    // Move the original nodes: policy links and Shopify text remain intact.
    paragraphs.forEach(paragraph => details.append(paragraph));
  }
  enhance();
  new MutationObserver(enhance).observe(document.body, {childList: true, subtree: true});
})();
